<div
    [id]="id"
    class='agpr-block agpr-chartBlock agpr-contextMenu-parent'
    [ngClass]="{
        'agpr-block--editing': editing,
        'agpr-block--cannot-move': !block.canMove,
        'agpr-block--disabled': !block.actionable,
        'agpr-block--error': block.errors?.length
    }"
    role="group"
    (click)="onAction('edit', $event)"
    [agprLoading]="loading"
>
    @if (block.actionable) {
        @if (isInLayoutBlock || isInCuratorBlock) {
            @if (showMoveButtons && block.canMove) {
                <agpr-kebab-menu
                    #moveContextMenu
                    class="agpr-block-contextMenu agpr-block-contextMenu--topLeft agpr-block-inLayoutBlockMoveOptionsButton"
                    [id]="id + '_move'"
                    [style]="buttonTypes.contextMenu"
                    icon="fa-regular fa-duotone fa-arrows-up-down-left-right"
                    [panelPositionX]="panelPositions.left"
                    [options]="inLayoutBlockMovingOptions"
                    [showIcon]="true"
                    [loading]="null"
                    tooltip="PageBuilder.blockIcon.move"
                    tooltipPosition="top"
                ></agpr-kebab-menu>
            }
            <agpr-kebab-menu
                class="agpr-block-contextMenu agpr-block-contextMenu--topRight agpr-block-moreOptionsButton"
                [id]="id + '_moreOptions'"
                [style]="buttonTypes.contextMenu"
                [panelPositionX]="panelPositions.right"
                [options]="editingOptions"
                [showIcon]="true"
                [loading]="null"
                tooltip="PageBuilder.blockIcon.moreOptions"
                tooltipPosition="top"
                [textAlignment]="actionMenuTextAlignment"
            ></agpr-kebab-menu>
        } @else {
            @if (showMoveButtons && block.canMove) {
                <agpr-kebab-menu
                    #moveContextMenu
                    class="agpr-block-contextMenu agpr-block-contextMenu--topLeft agpr-block-contextMenu--topLeft--outside"
                    [id]="id + '_move'"
                    [style]="buttonTypes.contextMenu"
                    icon="fa-regular fa-duotone fa-arrows-up-down-left-right"
                    [panelPositionX]="panelPositions.left"
                    [disabled]="!block.canMoveUp && !block.canMoveDown"
                    [options]="movingOptions"
                    [showIcon]="true"
                    [loading]="null"
                    tooltip="PageBuilder.blockIcon.move"
                    tooltipPosition="top"
                ></agpr-kebab-menu>
            }
            <ul
                role="menu"
                class="agpr-block-contextMenu agpr-block-contextMenu--topRight--outside"
                [attr.aria-label]="'PageBuilder.blockMenu.edit' | localize"
            >
                @if (block.canAddChart) {
                    <li role="menuitem">
                        <agpr-button
                            class="agpr-block-contextButton"
                            [id]="id + '_chart'"
                            [style]="buttonTypes.contextMenu"
                            icon="fa-pie-chart fa-duotone fa-regular"
                            tooltip="PageBuilder.briefings.blockIcon.addChart"
                            tooltipPosition="top"
                            (click)="onAction('chart')"
                        ></agpr-button>
                    </li>
                }
                @if (block.canEditChart) {
                    <li role="menuitem">
                        <agpr-button
                            class="agpr-block-contextButton"
                            [id]="id + '_chart'"
                            [style]="buttonTypes.contextMenu"
                            icon="fa-pie-chart fa-duotone fa-regular"
                            tooltip="PageBuilder.briefings.blockIcon.editChart"
                            tooltipPosition="top"
                            (click)="onAction('chart')"
                        ></agpr-button>
                    </li>
                }
                @if (block.canAnnotate) {
                    <li role="menuitem">
                        <agpr-button
                            class="agpr-block-contextButton"
                            [id]="id + '_annotate'"
                            [style]="buttonTypes.contextMenu"
                            icon="fa-kit-duotone fa-agpr-annotate"
                            tooltip="Reports.chartSetupDialog.annotate"
                            tooltipPosition="top"
                            (click)="onAction('annotate')"
                        ></agpr-button>
                    </li>
                }
                @if (block.canDuplicate) {
                    <li role="menuitem">
                        <agpr-button
                            class="agpr-block-contextButton"
                            [id]="id + '_duplicate'"
                            [style]="buttonTypes.contextMenu"
                            icon="fa-regular fa-duotone fa-clone"
                            tooltip="PageBuilder.briefings.blockIcon.duplicate"
                            tooltipPosition="top"
                            (click)="onAction('duplicate')"
                        ></agpr-button>
                    </li>
                }
                @if (block.canAddOrRemove) {
                    <li role="menuitem">
                        <agpr-button
                            class="agpr-block-contextButton"
                            [id]="id + '_delete'"
                            [style]="buttonTypes.contextMenu"
                            icon="fa-regular fa-duotone fa-trash-can"
                            tooltip="PageBuilder.briefings.blockIcon.delete"
                            tooltipPosition="top"
                            (click)="onAction('delete')"
                        ></agpr-button>
                    </li>
                }
            </ul>
            <ul
                #addToTop
                role="menu"
                class="agpr-block-contextMenu agpr-block-contextMenu--center-top"
                [ngClass]="{ 'agpr-block-contextMenu--hidden': addBottomExpanded }"
                [attr.aria-label]="'PageBuilder.blockMenu.add' | localize"
                (mouseleave)="leaveContextMenu(addToTop, $event, true)"
            >
                <li role="menuitem">
                    @if (inlineAdderAdjustment) {
                        <agpr-kebab-menu
                            class="agpr-block-contextButton agpr-block-contextButton--topLeft agpr-block-contextButton--topRight agpr-inline-addTop-button"
                            [id]="id + '_addTop_moreOptions'"
                            icon="fa-regular fa-duotone fa-plus"
                            [style]="buttonTypes.contextMenu"
                            [panelPositionX]="panelPositions.right"
                            [options]="optionsTop"
                            [showIcon]="true"
                            [loading]="null"
                            tooltip="PageBuilder.briefings.blockIcon.addBlock"
                            tooltipPosition="top"
                            ariaLabel="PageBuilder.briefings.blockIcon.addBlock.toTop"
                            [panelAlignCenter]="true"
                            [textAlignment]="actionMenuTextAlignment"
                        ></agpr-kebab-menu>
                    }@else {
                        <agpr-button
                            class="agpr-block-contextButton agpr-block-contextButton--topLeft agpr-block-contextButton--topRight agpr-inline-addTop-button"
                            [id]="id + '_addTop'"
                            [style]="buttonTypes.contextMenu"
                            icon="fa-regular fa-duotone fa-plus"
                            tooltip="PageBuilder.briefings.blockIcon.addBlock"
                            tooltipPosition="top"
                            ariaLabel="PageBuilder.briefings.blockIcon.addBlock.toTop"
                            [expanded]="addTopExpanded"
                            (click)="inlineAddToggle($event)"
                        ></agpr-button>
                        <div
                            class="agpr-block-contextMenu-adderContainer"
                            (focusout)="leaveContextMenu(addToTop, $event)"
                        >
                            <div class="agpr-block-contextMenu-adder">
                                <label class="agpr-block-contextMenu-adder-header">
                                    {{ 'PageBuilder.inlineAdder.components' | localize | uppercase }}
                                </label>
                                <agpr-block-adder
                                    [id]="id + '_above_' + blockAdderId"
                                    [addAtPosition]="blockPosition"
                                ></agpr-block-adder>
                                @if (areLayoutBlocksAllowed) {
                                    <label class="agpr-block-contextMenu-adder-header agpr-block-contextMenu-adder-header-layout">{{ 'PageBuilder.inlineAdder.layouts' | localize | uppercase }}</label>
                                    <agpr-layout-block-adder
                                        [id]="id + '_above_' + blockAdderId + '_layout'"
                                        [addAtPosition]="blockPosition"
                                        [isInline]="true"
                                    ></agpr-layout-block-adder>
                                }
                            </div>
                        </div>
                    }
                </li>
            </ul>
            @if (showMoveButtons && block.canMove) {
                <ul
                    #addToBottom
                    role="menu"
                    class="agpr-block-contextMenu agpr-block-contextMenu--center-bottom"
                    [ngClass]="{'agpr-block-contextMenu--hidden': addTopExpanded}"
                    [attr.aria-label]="'PageBuilder.blockMenu.add' | localize"
                    (mouseleave)="leaveContextMenu(addToBottom, $event, true)"
                >
                    <li role="menuitem">
                         @if (inlineAdderAdjustment) {
                            <agpr-kebab-menu
                                class="agpr-block-contextButton agpr-block-contextButton--bottomLeft agpr-block-contextButton--bottomRight"
                                [id]="id + '_addBottom_moreOptions'"
                                icon="fa-regular fa-duotone fa-plus"
                                [style]="buttonTypes.contextMenu"
                                [panelPositionX]="panelPositions.right"
                                [options]="optionsBottom"
                                [showIcon]="true"
                                [loading]="null"
                                tooltip="PageBuilder.briefings.blockIcon.addBlock"
                                tooltipPosition="top"
                                ariaLabel="PageBuilder.briefings.blockIcon.addBlock.toBottom"
                                [panelAlignCenter]="true"
                                [textAlignment]="actionMenuTextAlignment"
                            ></agpr-kebab-menu>
                        }@else {
                            <agpr-button
                                [id]="id + '_addBottom'"
                                class="agpr-block-contextButton agpr-block-contextButton--bottomLeft agpr-block-contextButton--bottomRight"
                                icon="fa-regular fa-duotone fa-plus"
                                tooltip="PageBuilder.briefings.blockIcon.addBlock"
                                tooltipPosition="bottom"
                                ariaLabel="PageBuilder.briefings.blockIcon.addBlock.toBottom"
                                [expanded]="addBottomExpanded"
                                (click)="inlineAddToggle($event)"
                                [style]="buttonTypes.contextMenu"
                            ></agpr-button>
                            <div
                                class="agpr-block-contextMenu-adderContainer"
                                (focusout)="leaveContextMenu(addToBottom, $event)"
                            >
                                <div class="agpr-block-contextMenu-adder">
                                    <label class="agpr-block-contextMenu-adder-header">{{ 'PageBuilder.inlineAdder.components' | localize | uppercase }}</label>
                                    <agpr-block-adder
                                        [id]="id + '_below_' + blockAdderId"
                                        [addAtPosition]="blockPositionBottom"
                                    ></agpr-block-adder>
                                    @if (areLayoutBlocksAllowed) {
                                        <label class="agpr-block-contextMenu-adder-header agpr-block-contextMenu-adder-header-layout">{{ 'PageBuilder.inlineAdder.layouts' | localize | uppercase }}</label>
                                        <agpr-layout-block-adder
                                            [id]="id + '_below_' + blockAdderId + '_layout'"
                                            [addAtPosition]="blockPositionBottom"
                                            [isInline]="true"
                                        ></agpr-layout-block-adder>
                                    }
                                </div>
                            </div>
                        }
                    </li>
                </ul>
            }
        }
    }

    <!-- chart -->
    <div
        #blockContent
        class="agpr-block-content agpr-chartBlock-content"
    >
        @if (renderable) {
            @if (block?.displayElement?.chartBlock?.type?.key === reportBlockTypeEnum.COVERAGE_SUMMARY) {
                @if (isCanvas) {
                    <agpr-canvas-chart
                        [type]="block.displayElement.chartBlock.type.key"
                        [chart]="chart"
                        [dataListChartOptions]="dataListChartOptions"
                        [nonAmChartSeries]="nonAmChartSeries"
                        (noData)="updateNoData($event)"
                        [data]="twigData"
                    ></agpr-canvas-chart>
                } @else {
                    <div
                        class="data-chart"
                        [ngStyle]="{ width: blockWidth + 'px' }"
                    >
                        <div
                            #coverageSummaryChart
                            class="agpr-coverageSummary-container"
                        >
                            @if (chartDisplayElement?.chartHeaderSettings?.title
                                || chartDisplayElement?.chartHeaderSettings?.dateRange
                                || chartDisplayElement?.chartHeaderSettings?.sourceLink
                            ) {
                                <div class="agpr-coverageSummaryChart-metadata">
                                    @if (chartDisplayElement?.chartHeaderSettings?.title) {
                                        <div class="agpr-chartBlockMetadata-title">
                                            <label tabindex="0">{{ chartDisplayElement?.title }}</label>
                                        </div>
                                    }
                                    @if (chartDisplayElement?.chartHeaderSettings?.dateRange || chartDisplayElement?.chartHeaderSettings?.sourceLink) {
                                        <div class="agpr-chartBlockMetadata-subtitleGroup">
                                            @if (chartDisplayElement?.chartHeaderSettings?.dateRange) {
                                                <label
                                                    id="coverageSummaryChart_dateRange"
                                                    class="agpr-chartBlockMetadata-dateRange"
                                                    [pTooltip]="chartDisplayElement?.dateRangeLabel"
                                                    tooltipPosition="bottom"
                                                    tabindex="0"
                                                >
                                                    {{ chartDisplayElement?.dateRangeLabel }}
                                                </label>
                                            }
                                            @if (chartDisplayElement?.chartHeaderSettings?.sourceLink) {
                                                <span
                                                    class="agpr-chartBlockMetadata-source"
                                                    [ngClass]="{'noDate': !chartDisplayElement?.chartHeaderSettings?.dateRange}"
                                                    target="_blank"
                                                    [pTooltip]="nonAmChartSeries && nonAmChartSeries[0] ? nonAmChartSeries[0].label : ''"
                                                    tooltipPosition="bottom"
                                                    [attr.tabindex]="(nonAmChartSeries && nonAmChartSeries[0] && nonAmChartSeries[0].label) ? '0' : '-1'"
                                                >
                                                    {{ nonAmChartSeries && nonAmChartSeries[0] ? nonAmChartSeries[0].label : '' }}
                                                </span>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                            <div class="agpr-coverageSummary-chart">
                                @if (nonAmChartSeries) {
                                    <agpr-data-list-chart
                                        [responsive]="true"
                                        [block]="block"
                                        [forceBlockHeight]="blockHeight"
                                        [hasHeader]="chartDisplayElement?.chartHeaderSettings?.title
                                        || chartDisplayElement?.chartHeaderSettings?.dateRange
                                        || chartDisplayElement?.chartHeaderSettings?.sourceLink ? 75 : 0"
                                        [series]="nonAmChartSeries"
                                        [colors]="chartDisplayElement?.styles?.colorMap"
                                        [chartOptions]="dataListChartOptions"
                                        (dataChange)="generateImage(block?.displayElement?.chartBlock?.type?.key)"
                                        (sourceDeleted)="sourceDeleted($event)"
                                        [skinny] = "skinny"
                                    ></agpr-data-list-chart>
                                } @else {
                                    <div class="agpr-chartBlock-noChartMessage">
                                        <agpr-message
                                            [id]="id + '_dataSource_error'"
                                            [severity]="messageSeverityEnum.info"
                                        >
                                            {{ 'Reports.chart.noDataSource' | localize }}
                                        </agpr-message>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                    @if (twigData.url?.length > 0) {
                        <agpr-twig
                            [id]="id + '_twig'"
                            [twigTemplate]="block.type.twig"
                            [data]="twigData"
                            [generateOnSend]="blockDisplayElement.chart.generateOnSend"
                            (renderedOutput)="setRenderedOutput($event)"
                        ></agpr-twig>
                    }
                }
            } @else if (
                block?.displayElement?.chartBlock?.type?.key === reportBlockTypeEnum.TOP_TERMS &&
                chartDisplayElement.chartSpecificType === chartSpecificTypesEnum.CARD_LIST
            ) {
                @if (isCanvas) {
                    <agpr-canvas-chart
                        [type]="block.displayElement.chartBlock.type.key"
                        [chart]="chart"
                        [nonAmChartSeries]="nonAmChartSeries"
                        [topTermChartOptions]="chartOptions"
                        (noData)="updateNoData($event)"
                        [data]="twigData"
                    ></agpr-canvas-chart>
                } @else {
                    <div
                        class="data-chart"
                        [ngStyle]="{ width: blockWidth + 'px' }"
                    >
                        <div
                            #topTermChart
                            class="agpr-topTermChart-chart"
                        >
                            @if (chartDisplayElement?.chartHeaderSettings?.title
                                || chartDisplayElement?.chartHeaderSettings?.dateRange
                                || chartDisplayElement?.chartHeaderSettings?.sourceLink
                            ) {
                                <div class="agpr-chartBlockMetadata agpr-topTermChart-metadata">
                                    @if (chartDisplayElement?.chartHeaderSettings?.title) {
                                        <div class="agpr-chartBlockMetadata-title">
                                            <label> {{ chartDisplayElement?.title }} </label>
                                        </div>
                                    }

                                    @if (chartDisplayElement?.chartHeaderSettings?.dateRange || chartDisplayElement?.chartHeaderSettings?.sourceLink) {
                                        <div class="agpr-chartBlockMetadata-subtitleGroup">
                                            @if (chartDisplayElement?.chartHeaderSettings?.dateRange) {
                                                <div
                                                    class="agpr-chartBlockMetadata-dateRange"
                                                    [agprTooltip]="chartDisplayElement?.dateRangeLabel"
                                                    tooltipPosition="bottom"
                                                >
                                                    {{ chartDisplayElement?.dateRangeLabel }}
                                                </div>
                                            }

                                            @if (chartDisplayElement?.chartHeaderSettings?.sourceLink) {
                                                <span
                                                    class="agpr-chartBlockMetadata-source"
                                                    [ngClass]="{'noDate': !chartDisplayElement?.chartHeaderSettings?.dateRange}"
                                                    [pTooltip]="nonAmChartSeries && nonAmChartSeries[0] ? nonAmChartSeries[0].label : ''"
                                                    tooltipPosition="bottom"
                                                    [attr.tabindex]="(nonAmChartSeries && nonAmChartSeries[0] && nonAmChartSeries[0].label) ? '0' : '-1'"
                                                >
                                                    {{ nonAmChartSeries && nonAmChartSeries[0] ? nonAmChartSeries[0].label : '' }}
                                                </span>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                            <div
                                class="agpr-topTermChart-container"
                                [ngClass]="{
                                    'agpr-topTermChart--small': topTermSmall
                                }"
                            >
                                @if (nonAmChartSeries?.length > 0) {
                                    <agpr-scroll-panel>
                                        <agpr-top-terms-chart
                                            [series]="nonAmChartSeries"
                                            [accentColor]="barColor"
                                            [numOfItems]="chartDisplayElement.numOfItems"
                                            [focusable]="false"
                                            [chartOptions]="chartOptions"
                                            (sourceDeleted)="sourceDeleted($event)"
                                            (dataChange)="generateImage(block?.displayElement?.chartBlock?.type?.key)"
                                            [noContentMessage]="'Common.noContentToDisplay' | localize"
                                        ></agpr-top-terms-chart>
                                    </agpr-scroll-panel>
                                } @else {
                                    <agpr-message
                                        class="agpr-chartBlock-noChartMessage"
                                        [id]="id + '_dataSource_error'"
                                        [severity]="messageSeverityEnum.error"
                                    >
                                        {{ 'Reports.error.folderRemoved' | localize }}
                                    </agpr-message>
                                }
                            </div>
                        </div>
                    </div>
                }

                @if (twigData.url?.length > 0) {
                    <agpr-twig
                        [id]="id + '_twig'"
                        [twigTemplate]="block.type.twig"
                        [data]="twigData"
                        [generateOnSend]="blockDisplayElement.chart.generateOnSend"
                        (renderedOutput)="setRenderedOutput($event)"
                    ></agpr-twig>
                }
            } @else if (
                (block?.displayElement?.chartBlock?.type?.key === reportBlockTypeEnum.TOP_10_OUTLETS
                || block?.displayElement?.chartBlock?.type?.key === reportBlockTypeEnum.TOP_10_AUTHORS_BY_VOLUME)
                && chartDisplayElement.chartHeaderSettings.entityProfile
            ) {
                @if (isCanvas) {
                    <agpr-canvas-chart
                        [data]="twigData"
                        [nonAmChartSeries]="nonAmChartSeries"
                        [type]="block?.displayElement?.chartBlock?.type?.key"
                        [width]="chartContentWidth"
                        [height]="chartContentHeight"
                    ></agpr-canvas-chart>
                }
            } @else if (block?.displayElement?.chartBlock?.type?.key === reportBlockTypeEnum.COVERAGE_METRIC) {
                @if (isCanvas) {
                    <agpr-canvas-chart
                        [type]="block.displayElement.chartBlock.type.key"
                        [data]="twigData"
                        [nonAmChartSeries]="nonAmChartSeries"
                    ></agpr-canvas-chart>
                } @else {
                    <div
                        class="data-chart"
                        [ngStyle]="{ width: blockWidth + 'px' }"
                    >
                        <div
                            #coverageMetricChart
                            class="agpr-coverageMetricChart-chart"
                        >
                            @if (nonAmChartSeries?.length > 0) {
                                <agpr-coverage-metric-chart
                                    [series]="nonAmChartSeries?.[0]"
                                    [accentColor]="barColor"
                                    [displayElement]="chartDisplayElement"
                                    (dataChange)="generateImage(block?.displayElement?.chartBlock?.type?.key)"
                                    (sourceDeleted)="sourceDeleted($event)"
                                ></agpr-coverage-metric-chart>
                            } @else {
                                <agpr-message
                                    class="agpr-chartBlock-noChartMessage"
                                    [id]="id + '_dataSource_error'"
                                    [severity]="messageSeverityEnum.error"
                                >
                                    {{ 'Reports.error.folderRemoved' | localize }}
                                </agpr-message>
                            }

                        </div>
                    </div>
                }
                @if (twigData.url?.length > 0) {
                    <agpr-twig
                        [id]="id + '_twig'"
                        [twigTemplate]="block.type.twig"
                        [data]="twigData"
                        [generateOnSend]="blockDisplayElement.chart.generateOnSend"
                        (renderedOutput)="setRenderedOutput($event)"
                    ></agpr-twig>
                }

            } @else if (chart || am5Chart || blockDisplayElement.chart.chartUrl) {
                <!-- the metadata only renders when the chart fails to get data, otherwise metadata is rendered via amcharts -->
                @if (noData && !blockDisplayElement.chart.chartUrl) {
                    <div class="agpr-chartBlockMetadata">
                        <div class="agpr-chartBlockMetadata-title">
                            {{ chartDisplayElement?.title }}
                        </div>
                        <div class="agpr-chartBlockMetadata-subtitleGroup">
                            <div class="agpr-chartBlockMetadata-dateRange">
                                {{ chartDisplayElement?.dateRangeLabel }}
                            </div>
                            <div class="agpr-chartBlockMetadata-source">
                                {{ chartDisplayElement?.nonAmChartSeries?.[0]?.label }}
                            </div>
                        </div>
                    </div>
                }

                @if (!isProminenceChart || hasProminenceProvision) {
                    <div
                        class="agpr-chartBlock-chart"
                        [ngClass]="{'agpr-chartBlock-chart--noData': (noData && !blockDisplayElement.chart.chartUrl) }"
                    >
                        @if (isCanvas) {
                            <agpr-canvas-chart
                                #amCanvasChart
                                [ngClass]="{'agpr-chartBlock--hasAnnotation': hasAnnotation}"
                                [type]="block?.displayElement?.chartBlock?.type?.key"
                                [chart]="chart"
                                [am5Chart]="am5Chart"
                                [reportSeries]="reportSeries"
                                (noData)="updateNoData($event)"
                                [data]="twigData"
                            ></agpr-canvas-chart>
                        } @else {
                            @if (am5BlockTypes.includes(block?.displayElement?.chartBlock?.type?.key)) {
                                <agpr-am5-briefing-chart
                                    #am5EmailBriefingChart
                                    [chart]="am5Chart"
                                    [briefingChartDisplayElement]="block.displayElement"
                                    [imageWidth]="chartContentWidth"
                                    [generateOnSend]="blockDisplayElement.chart.generateOnSend"
                                    [twigTemplate]="block.type.twig"
                                    [twigData]="twigData"
                                    [onExportResized]="handleChartExportResized"
                                    (noData)="updateNoData($event)"
                                    (sourceDeleted)="sourceDeleted($event)"
                                    (imageGenerated)="generateImage(block?.displayElement?.chartBlock?.type?.key, $event)"
                                ></agpr-am5-briefing-chart>
                            } @else {
                                <agpr-briefing-chart
                                    [blockPosition]="blockPosition"
                                    [chart]="chart"
                                    [block]="block"
                                    [twigData]="twigData"
                                    [generateOnSend]="blockDisplayElement.chart.generateOnSend"
                                    (noData)="updateNoData($event)"
                                    (sourceDeleted)="sourceDeleted($event)"
                                    (generateImage)="generateImage(block?.displayElement?.chartBlock?.type?.key, $event)"
                                ></agpr-briefing-chart>
                            }
                        }
                    </div>
                }

                @if (missingDataSource && !blockDisplayElement.chart.chartUrl) {
                    <div class="agpr-chartBlock-noChartMessage">
                        <agpr-message
                            [id]="id + '_missingDataSource_error'"
                            [severity]="messageSeverityEnum.error"
                            [closeable]="true"
                        >
                            {{ 'Reports.error.dataSourceNoLongerAvailable.some' | localize }}
                        </agpr-message>
                    </div>
                }

                @if (noData && !blockDisplayElement.chart.chartUrl) {
                    <div class="agpr-chartBlock-noChartMessage">
                        <agpr-message
                            [id]="id + '_dataLoadFailure'"
                            [severity]="messageSeverityEnum.error"
                        >
                            {{ 'Reports.chart.dataLoadFailure' | localize }}
                        </agpr-message>
                    </div>
                }
            }

            @if (isProminenceChart && (prominenceStatus !== prominenceStatuses.DONE) && hasProminenceProvision) {
                <div class="agpr-chartBlock-noChartMessage">
                    <agpr-message
                        [id]="id + '_prominence_error'"
                        [severity]="prominenceStatus === prominenceStatuses.FAILED ? 'error' : 'warning'"
                    >
                        @if (prominenceStatus === prominenceStatuses.ONGOING || prominenceStatus === prominenceStatuses.PENDING) {
                            {{ 'AccountPreferences.prominence.disclaimer.cannotEdit' | localize }}
                        } @else if (prominenceStatus === prominenceStatuses.FAILED) {
                            {{ 'AccountPreferences.prominence.disclaimer.contactEngineering' | localize }}
                        }
                    </agpr-message>
                </div>
            }
        } @else {
            <div class='agpr-chartBlock-placeholder'>
                <div class="agpr-chartBlock-placeholder-topRow">
                    <span
                        class="fa agpr-chartBlock-placeholderIcon {{ block.type.icon }}"
                        [aria-hidden]="true"
                    ></span>
                    <span class="agpr-chartBlock-placeholderLabel">
                        {{ block.type.label | localize }}
                    </span>
                </div>
            </div>
        }
    </div>

    @if (isProminenceChart && !hasProminenceProvision) {
        <div class="agpr-chartBlock-noProminence">
            <agpr-message
                [id]="id + '_prominence_error'"
                [severity]="messageSeverityEnum.info"
            >
                <div [innerHTML]="'AccountPreferences.prominence.disclaimer.noProminence' | localize: { contactLink: noProminenceContactLink }"></div>
            </agpr-message>
        </div>
    }
    <div class="agpr-block-hoverBorder agpr-chartBlock-hoverBorder"></div>
</div>

@if (block.errors?.length > 0) {
    <ul
        [id]="id + '_errors'"
        class="agpr-blockError"
    >
        @for (error of block.errors; track error) {
            <li>
                <agpr-form-message>
                    {{ error | localize}}
                </agpr-form-message>
            </li>
        }
    </ul>
}


